<h1 class="pf-tt">{{ isEdit ? 'Editar mascota' : 'Agregar una mascota' }}</h1>
<p class="pf-sub">Cinco datos y listo. El resto lo podés completar cuando quieras.</p>

<div class="mc-blk" *ngIf="!isLoading">

  <!-- Foto: compacta, no el icono gigante del formulario viejo. El label abre el
       selector de archivo de forma nativa (mas robusto que un click via JS). -->
  <div class="pf-foto-row">
    <label class="pf-foto" for="pfFotoInput">
      <img *ngIf="tieneFoto" [src]="getImage()" alt="Foto">
      <span *ngIf="!tieneFoto" class="pf-foto-ph">+</span>
    </label>
    <label class="pf-foto-btn" for="pfFotoInput">
      {{ tieneFoto ? 'Cambiar foto' : 'Agregar una foto' }}
    </label>
    <input id="pfFotoInput" type="file" accept="image/*" (change)="cargarImagen($event)" style="display:none">
  </div>

  <div class="pf-fields">

    <div class="pf-f pf-f-ancho">
      <label for="pfNombre">Nombre</label>
      <input id="pfNombre" name="name" [(ngModel)]="pet.name" placeholder="Cómo se llama">
    </div>

    <div class="pf-f pf-f-ancho">
      <label>Especie</label>
      <div class="pf-seg">
        <button type="button" class="pf-segb" *ngFor="let s of especies"
                [class.on]="pet.speciesId === s.id" (click)="elegirEspecie(s)">
          {{ nombreEspecie(s) }}
        </button>
      </div>
    </div>

    <div class="pf-f pf-f-ancho">
      <label for="pfRaza">Raza</label>
      <div class="pf-combo">
        <input id="pfRaza" [(ngModel)]="razaTexto" name="razaTexto"
               [disabled]="!pet.speciesId"
               (input)="alEscribirRaza()" (focus)="abrirListaRaza()" (blur)="cerrarListaRaza()"
               [placeholder]="pet.speciesId ? 'Elegí o escribí para buscar' : 'Elegí primero la especie'"
               autocomplete="off">
        <div class="pf-opciones" *ngIf="razaListaAbierta && razasFiltradas.length">
          <button type="button" *ngFor="let r of razasFiltradas"
                  [class.sel]="pet.breedId === r.id" (click)="elegirRaza(r)">{{ r.name }}</button>
        </div>
      </div>
    </div>

    <div class="pf-f pf-f-ancho">
      <label>Sexo</label>
      <div class="pf-seg pf-seg-2">
        <button type="button" class="pf-segb" *ngFor="let g of generos"
                [class.on]="pet.gender === g.id" (click)="elegirSexo(g.id)">
          {{ g.etiqueta }}
        </button>
      </div>
    </div>

    <div class="pf-f pf-f-ancho">
      <label>Fecha de nacimiento</label>

      <!-- Modo exacto -->
      <ng-container *ngIf="!fechaAproximada">
        <input type="date" name="birthdate" [(ngModel)]="fechaNacimiento"
               [max]="today | date:'yyyy-MM-dd'" min="1990-01-01" class="pf-fecha-input">
        <div class="pf-hint">
          <span *ngIf="edadCalculada">{{ edadCalculada }}. </span>
          Si la sabés exacta, lo saludamos en su cumpleaños.
          <button type="button" class="pf-lnk" (click)="usarFechaAproximada(true)">No sé la fecha exacta</button>
        </div>
      </ng-container>

      <!-- Modo aproximado -->
      <ng-container *ngIf="fechaAproximada">
        <div class="pf-edad">
          <input type="number" min="0" [(ngModel)]="edadValor" name="edadValor" placeholder="2" class="pf-edad-num">
          <select [(ngModel)]="edadUnidad" name="edadUnidad" class="pf-edad-un">
            <option value="anios">años</option>
            <option value="meses">meses</option>
          </select>
        </div>
        <div class="pf-hint">
          Con la edad aproximada alcanza para saber en qué etapa está.
          <button type="button" class="pf-lnk" (click)="usarFechaAproximada(false)">Sé la fecha exacta</button>
        </div>
      </ng-container>
    </div>

  </div>

  <div class="pf-acts">
    <button class="pf-btn" [disabled]="!formValido" (click)="save()">
      {{ isEdit ? 'Guardar cambios' : 'Agregar' }}
    </button>
    <button class="pf-lnk-cancel" [routerLink]="isEdit ? ['/mis-mascotas'] : ['/home']">Cancelar</button>
  </div>

</div>

<loading-indicator *ngIf="isLoading"></loading-indicator>
